define(['jquery', 'jquery.transit', 'modernizr', 'container', 'slider', 'preloader', 'jump'],
    function ($, transit, modernizr, container, sliderFactory, preloader, jumpFactory) {

        const mediaCarouselVideoPlayAction = () => {
            return {
                type: 'MEDIA_CAROUSEL_VIDEO_PLAY',
                payload: {
                    videoPlaying: true
                }
            }
        };

        const mediaCarouselVideoStopAction = () => {
            return {
                type: 'MEDIA_CAROUSEL_VIDEO_STOP',
                payload: {
                    videoPlaying: false
                }
            }
        };

        const mediaCarouselAddPlayersAction = (players) => {
            return {
                type: 'MEDIA_CAROUSEL_VIDEO_PLAYERS_ADD',
                payload: {
                    videoPlayers: players
                }
            }
        };

        const mediaCarouselPlayReducer = (play = false, action) => {
            switch (action.type) {
                case 'MEDIA_CAROUSEL_VIDEO_PLAY':
                    return action.payload.videoPlaying;
                case 'MEDIA_CAROUSEL_VIDEO_STOP':
                    return action.payload.videoPlaying;
                default:
                    return play;
            }
        };

        const mediaCarouselPlayerReducer = (players = null, action) => {
            if (action.type === 'MEDIA_CAROUSEL_VIDEO_PLAYERS_ADD') {
                return action.payload.videoPlayers;
            } else {
                return players;
            }
        };

        return (function () {

            const name = 'module-media-carousel';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            //const pubSub = container.getPublishSubscribe();
            const slider = sliderFactory.create();
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {
                players: new Map(),
                scrollBlock: false,

                touchStart: 0,
                touchDiff: 0,
                touchStartY: 0,
                touchDiffY: 0,

                slideStarted: false,
                endTrans: false,
                interval: '', /* interval handler */
            };

            view.startup = function () {

                container.getReduxStore().reducerManager.add('mediaCarouselVideoPlay', mediaCarouselPlayReducer);
                container.getReduxStore().reducerManager.add('mediaCarouselPlayers', mediaCarouselPlayerReducer);
                container.getReduxStore().dispatch(mediaCarouselVideoStopAction());
                container.getReduxStore().dispatch(mediaCarouselAddPlayersAction(null));

                preloader.setPreloadBulk(name, view.publicVars.preloadTab);

                slider.init(view.publicVars.sliderSetup);
                slider.setCallback('beforeSlideChange', view.methods.beforeSlideChange);
                slider.setCallback('afterSlideChange', view.methods.afterSlideChange);

                view.methods.loadVideoForSlide(slider.getCurrentItem());

            };

            view.bind = function () {
                $(view.publicVars.cssId.mediaCarouselPlayBtnCls).click(function () {
                    view.methods.playBackgroundVideo();
                });

                $(view.publicVars.cssId.mediaCarouselMuteBtnCls).click(function () {
                    view.methods.muteCurrentVideo();
                });

                $(window).resize(function () {
                    view.methods.handleScreenResize();
                });

                $(window).on("orientationchange", function () {
                    view.methods.handleScreenResize();
                });

                $(window).scroll(function () {

                    var ticking = false;

                    if (!ticking) {
                        window.requestAnimationFrame(function () {
                            view.methods.handleCurrentScrollPosition();
                            ticking = false;
                        });
                    }
                    ticking = true;

                });

                $(view.publicVars.cssId.mediaCarouselMobileDetailsWrapperCls).bind('touchstart', function(e) {
                    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.slideMouseDown(touch);
                });


                $(view.publicVars.cssId.mediaCarouselMobileDetailsWrapperCls).bind('touchmove', function(e) {
                    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.slideMouseMove(touch, e);
                });

                $(view.publicVars.cssId.mediaCarouselMobileDetailsWrapperCls).bind('touchend', function(e) {
                    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return view.methods.slideMouseUp(touch);
                });
            };

            view.methods = {

                slideMouseDown: function(e) {

                    if (!view.privateVars.slideStarted)
                    {
                        view.privateVars.touchStart = e.pageX;
                        view.privateVars.touchStartY = e.pageY;

                        view.privateVars.slideStarted = true;

                    }

                    //return false;

                },

                slideMouseMove: function(e, ev) {

                    if (view.privateVars.slideStarted && !view.privateVars.endTrans)
                    {
                        view.privateVars.touchDiff = view.privateVars.touchStart - e.pageX;
                        view.privateVars.touchDiffY = view.privateVars.touchStartY - e.pageY;

                        // if (view.privateVars.touchDiff < -40) {
                        //     slider.changeSlideLeft();
                        //
                        // } else if (view.privateVars.touchDiff > 40) {
                        //     slider.changeSlideRight();
                        // }

                        if (Math.abs(view.privateVars.touchDiff) >= Math.abs(view.privateVars.touchDiffY)) {
                            ev.preventDefault();
                        }
                    }

                    //return false;
                },

                slideMouseUp: function(e) {

                    if (view.privateVars.slideStarted)
                    {
                        view.privateVars.endTrans = true;
                        if (view.privateVars.touchDiff < -40) {
                            slider.changeSlideLeft();
                        } else if (view.privateVars.touchDiff > 40) {
                            slider.changeSlideRight();
                        } else {

                            view.privateVars.touchDiff = 0;
                            view.privateVars.touchStart = 0;

                            view.privateVars.touchDiffY = 0;
                            view.privateVars.touchStartY = 0;


                            view.privateVars.slideStarted = false;
                            view.privateVars.endTrans = false;
                        }
                    } else {
                        view.privateVars.slideStarted = false;
                        view.privateVars.endTrans = false;
                    }
                },

                loadVideoForSlide: (currentItem) => {

                    const video = container.getData($(view.publicVars.cssId.sliderItemCls + currentItem)[0], 'video');

                    if (!view.privateVars.players.has(currentItem) && video) {
                        view.methods.setupBitmovin(currentItem, view.publicVars.cssId.mediaCarouselVideoPlayerId.substr(1) + currentItem, {
                            autoplay: false,
                            source: {
                                progressive: video
                            }
                        });
                    }
                },

                muteCurrentVideo: () => {
                    const currentItem = slider.getCurrentItem();

                    if (view.privateVars.players.get(currentItem) && view.privateVars.players.get(currentItem).isMuted()) {
                        view.privateVars.players.get(currentItem).unmute();
                    } else {
                        view.privateVars.players.get(currentItem).mute();
                    }
                },

                playBackgroundVideo: () => {

                    const currentItem = slider.getCurrentItem();

                    const header = container.getData($(view.publicVars.cssId.sliderItemCls + currentItem)[0], 'header');
                    const subheader = container.getData($(view.publicVars.cssId.sliderItemCls + currentItem)[0], 'subheader');
                    const infoTxt = container.getData($(view.publicVars.cssId.sliderItemCls + currentItem)[0], 'info.text');

                    let contenttitle = 'featured carousel slide: ' + currentItem;

                    if (header != '') {
                        contenttitle = header;
                    } else if (subheader != '') {
                        contenttitle = subheader;
                    } else if (infoTxt != '') {
                        contenttitle = infoTxt;
                    }

                    contenttitle = contenttitle.toLowerCase().replace(/"/g, "'");

                    if (view.privateVars.players.get(currentItem) && view.privateVars.players.get(currentItem).isPlaying()) {
                        view.privateVars.players.get(currentItem).pause();
                    } else {
                        view.privateVars.players.get(currentItem).play();
                        container.trackInteraction('featured content video click', {
                            'subsection': 'home|featured',
                            'contenttype': 'featured carousel',
                            'contenttitle': contenttitle
                        });
                    }
                },

                setupBitmovin: (id, videoPlayerId, options) => {

                    const conf = {
                        key: view.publicVars.bitmovinKey,
                        analytics: false,
                        ui: false,
                        playback: {
                            autoplay: options.autoplay || false,
                            muted: true
                        },
                        logs: {
                            level: 'off'
                        },

                    };

                    let source = options.source || {
                        progressive: view.publicVars.introVideoSource
                    };

                    if (view.publicVars.introVideoPoster && !options.source) {
                        source.poster = view.publicVars.introVideoPoster;
                    }

                    let player = new bitmovin.player.Player(document.getElementById(videoPlayerId), conf);

                    // Setup the player
                    player.load(source).then(function () {

                    }, function () {

                    });

                    player.on(bitmovin.player.PlayerEvent.Play, function (e) {

                        const state = container.getReduxStore().getState();

                        if (state.videoCarouselPlayer && state.videoCarouselVideoPlay) {
                            state.videoCarouselPlayer.pause();
                        }

                        view.privateVars.scrollBlock = true;
                        jump.centerTo(view.publicVars.cssId.sliderItemCls + id, () => {
                            view.privateVars.scrollBlock = false;
                        }, {stripAdjust: true, speed: 350});

                        view.methods.calculateMediaBtnPosition(id);

                        $(view.publicVars.cssId.mediaCarouselInfoId + id).addClass(view.publicVars.cssId.isPlayingCls.substr(1));
                        $(view.publicVars.cssId.mediaCarouselMoreBtnId + id).addClass(view.publicVars.cssId.isPlayingCls.substr(1));
                        $(view.publicVars.cssId.mediaCarouselMoreBtnId + id).stop(true, true);
                        $(view.publicVars.cssId.mediaCarouselMoreBtnId + id).removeAttr('style');

                        $(view.publicVars.cssId.mediaCarouselImageId + id).transit({opacity: 0});

                        $(view.publicVars.cssId.mediaCarouselArrowCls).transit({opacity: 0, visibility: 'hidden'});

                        $('#' + view.publicVars.cssId.mediaCarouselPlayBtnCls.substr(1) + id).addClass(view.publicVars.cssId.isPlayingCls.substr(1));

                        container.getReduxStore().dispatch(mediaCarouselVideoPlayAction());

                        $(view.publicVars.cssId.headerCls).addClass(view.publicVars.cssId.hasTopPosCls.substr(1));
                    });

                    player.on(bitmovin.player.PlayerEvent.Paused, function (e) {
                        $(view.publicVars.cssId.mediaCarouselInfoId + id).removeClass(view.publicVars.cssId.isPlayingCls.substr(1));
                        $(view.publicVars.cssId.mediaCarouselMoreBtnId + id).removeClass(view.publicVars.cssId.isPlayingCls.substr(1));
                        $(view.publicVars.cssId.mediaCarouselMoreBtnId + id).css({ opacity: 0 });
                        setTimeout(() => {
                            $(view.publicVars.cssId.mediaCarouselMoreBtnId + id).transit({ opacity: 1}, 300);
                        }, 300);

                        $(view.publicVars.cssId.mediaCarouselInfoId + id).removeAttr('style');

                        $(view.publicVars.cssId.mediaCarouselArrowCls).transit({opacity: 1, visibility: 'visible'});

                        //$(view.publicVars.cssId.mediaCarouselImageId + id).transit({ opacity: 1});

                        $('#' + view.publicVars.cssId.mediaCarouselPlayBtnCls.substr(1) + id).removeClass(view.publicVars.cssId.isPlayingCls.substr(1));

                        container.getReduxStore().dispatch(mediaCarouselVideoStopAction());

                        $(view.publicVars.cssId.headerCls).removeClass(view.publicVars.cssId.hasTopPosCls.substr(1));
                    });

                    player.on(bitmovin.player.PlayerEvent.Playing, function (e) {

                    });

                    player.on(bitmovin.player.PlayerEvent.Muted, function (e) {
                        $('#' + view.publicVars.cssId.mediaCarouselMuteBtnCls.substr(1) + id).removeClass(view.publicVars.cssId.isUnmutedCls.substr(1));
                    });

                    player.on(bitmovin.player.PlayerEvent.Unmuted, function (e) {
                        $('#' + view.publicVars.cssId.mediaCarouselMuteBtnCls.substr(1) + id).addClass(view.publicVars.cssId.isUnmutedCls.substr(1));
                    });


                    player.on(bitmovin.player.PlayerEvent.PlaybackFinished, function (e) {
                        $(view.publicVars.cssId.mediaCarouselInfoId + id).removeClass(view.publicVars.cssId.isPlayingCls.substr(1));
                        $(view.publicVars.cssId.mediaCarouselMoreBtnId + id).removeClass(view.publicVars.cssId.isPlayingCls.substr(1));
                        $(view.publicVars.cssId.mediaCarouselMoreBtnId + id).css({ opacity: 0 });
                        setTimeout(() => {
                            $(view.publicVars.cssId.mediaCarouselMoreBtnId + id).transit({ opacity: 1}, 300);
                        }, 300);

                        $(view.publicVars.cssId.mediaCarouselInfoId + id).removeAttr('style');

                        $(view.publicVars.cssId.mediaCarouselImageId + id).transit({opacity: 1});

                        $(view.publicVars.cssId.mediaCarouselArrowCls).transit({opacity: 1, visibility: 'visible'});


                        $('#' + view.publicVars.cssId.mediaCarouselPlayBtnCls.substr(1) + id).removeClass(view.publicVars.cssId.isPlayingCls.substr(1));

                        container.getReduxStore().dispatch(mediaCarouselVideoStopAction());

                        $(view.publicVars.cssId.headerCls).removeClass(view.publicVars.cssId.hasTopPosCls.substr(1));

                    });

                    view.privateVars.players.set(parseInt(id), player);

                    container.getReduxStore().dispatch(mediaCarouselAddPlayersAction(view.privateVars.players));
                },

                calculateMediaBtnPosition: (id) => {
                    const adjustment = ($(window).height() - $(view.publicVars.cssId.sliderItemCls).outerHeight()) / 2;
                    let bottomSpaceValue = 20;

                    if($(window).width() < 500) {
                        bottomSpaceValue = 10;
                    }

                    if (adjustment < 0) {
                        $(view.publicVars.cssId.mediaCarouselInfoId + id).css({bottom: bottomSpaceValue - adjustment + 'px'});
                    }
                },

                handleScreenResize: () => {
                    if (view.privateVars.players.has(slider.getCurrentItem()) &&
                        view.privateVars.players.get(slider.getCurrentItem()).isPlaying()) {

                        view.privateVars.scrollBlock = true;

                        jump.centerTo(view.publicVars.cssId.sliderItemCls + slider.getCurrentItem(), () => {
                            view.privateVars.scrollBlock = false;
                        }, {stripAdjust: true, speed: 350});
                        view.methods.calculateMediaBtnPosition(slider.getCurrentItem());

                    }
                },

                handleCurrentScrollPosition: () => {
                    if (view.privateVars.players.has(slider.getCurrentItem()) &&
                        view.privateVars.players.get(slider.getCurrentItem()).isPlaying() && !view.privateVars.scrollBlock) {

                        const systemCurrentScroll = $(document).scrollTop();
                        const scrollPlusWindowHeight = $(window).height() + systemCurrentScroll;

                        const targetHandler = '#' + view.publicVars.cssId.mediaCarouselPlayBtnCls.substr(1) + slider.getCurrentItem();
                        const targetSlideHandler = view.publicVars.cssId.sliderItemCls + slider.getCurrentItem();

                        const targetPos = $(targetHandler).offset();
                        const targetPosSlide = $(targetSlideHandler).offset();

                        const rect = $(targetHandler)[0].getBoundingClientRect();
                        const rectSlide = $(targetSlideHandler)[0].getBoundingClientRect();

                        const bottomPos = parseInt(targetPosSlide.top) + parseInt(rectSlide.height);

                        const diff = bottomPos - scrollPlusWindowHeight;

                        let bottomSpaceValue = 20;

                        if($(window).width() < 500) {
                            bottomSpaceValue = 10;
                        }

                        let bottomVal = bottomSpaceValue;

                        if (diff > 0) {
                            bottomVal = diff + bottomSpaceValue;
                        }

                        $(view.publicVars.cssId.mediaCarouselInfoId + slider.getCurrentItem()).css({bottom: bottomVal + 'px'});
                    }
                },

                beforeSlideChange: (data) => {

                    const header = container.getData($(view.publicVars.cssId.sliderItemCls + data.newId)[0], 'header');
                    const subHeader = container.getData($(view.publicVars.cssId.sliderItemCls + data.newId)[0], 'subheader');
                    const infoText = container.getData($(view.publicVars.cssId.sliderItemCls + data.newId)[0], 'info.text');
                    const moreLink = container.getData($(view.publicVars.cssId.sliderItemCls + data.newId)[0], 'more.link');
                    const moreLinkTarget = container.getData($(view.publicVars.cssId.sliderItemCls + data.newId)[0], 'more.link.target');

                    view.methods.loadVideoForSlide(data.newId);

                    $(view.publicVars.cssId.mediaCarouselMobileDetailsInnerCls).css({opacity: 0, visibility: 'hidden'});
                    $(view.publicVars.cssId.mediaCarouselMobileLoadMoreLoadeCls).css({display: 'block', opacity: 0});
                    $(view.publicVars.cssId.mediaCarouselMobileLoadMoreLoadeCls).transit({opacity: 1}, 100);

                    $(view.publicVars.cssId.mediaCarouselMobileDetailsHeaderCls).html(header);
                    $(view.publicVars.cssId.mediaCarouselMobileDetailsSubHeaderCls).html(subHeader);
                    $(view.publicVars.cssId.mediaCarouselMobileDetailsInfoCls).html(infoText);
                    $(view.publicVars.cssId.mediaCarouselMobileDetailsMoreBtnCls).attr('href', moreLink);
                    $(view.publicVars.cssId.mediaCarouselMobileDetailsMoreBtnCls).attr('target', moreLinkTarget);
                    $(view.publicVars.cssId.mediaCarouselMobileDetailsCls).css({'minHeight': '100px'});

                    let displayFlag = false;

                    if (!header) {
                        $(view.publicVars.cssId.mediaCarouselMobileDetailsHeaderCls).css({display: 'none'});
                    } else {
                        $(view.publicVars.cssId.mediaCarouselMobileDetailsHeaderCls).css({display: 'block'});
                        displayFlag = true;
                    }

                    if (!subHeader) {
                        $(view.publicVars.cssId.mediaCarouselMobileDetailsSubHeaderCls).css({display: 'none'});
                    } else {
                        $(view.publicVars.cssId.mediaCarouselMobileDetailsSubHeaderCls).css({display: 'block'});
                        displayFlag = true;
                    }

                    if (!infoText) {
                        $(view.publicVars.cssId.mediaCarouselMobileDetailsInfoCls).css({display: 'none'});
                    } else {
                        $(view.publicVars.cssId.mediaCarouselMobileDetailsInfoCls).css({display: 'block'});
                        displayFlag = true;
                    }

                    if (!moreLink) {
                        $(view.publicVars.cssId.mediaCarouselMobileDetailsMoreBtnCls).css({display: 'none'});
                    } else {
                        $(view.publicVars.cssId.mediaCarouselMobileDetailsMoreBtnCls).css({display: 'block'});
                        displayFlag = true;
                    }

                    if (displayFlag) {
                        $(view.publicVars.cssId.mediaCarouselMobileDetailsCls).css({display: 'block', height: 'auto'});
                    } else {
                        $(view.publicVars.cssId.mediaCarouselMobileLoadMoreLoadeCls).css({display: 'none'});
                        $(view.publicVars.cssId.mediaCarouselMobileDetailsCls).css({display: 'none'});
                    }

                },
                afterSlideChange: (data) => {
                    view.privateVars.touchDiff = 0;
                    view.privateVars.touchStart = 0;

                    view.privateVars.touchDiffY = 0;
                    view.privateVars.touchStartY = 0;


                    view.privateVars.slideStarted = false;
                    view.privateVars.endTrans = false;

                    $(view.publicVars.cssId.mediaCarouselMobileDetailsCls).css({'minHeight': '0'});
                    $(view.publicVars.cssId.mediaCarouselMobileLoadMoreLoadeCls).css({display: 'none'});
                    $(view.publicVars.cssId.mediaCarouselMobileDetailsInnerCls).css({
                        opacity: 0,
                        visibility: 'visible'
                    });
                    $(view.publicVars.cssId.mediaCarouselMobileDetailsInnerCls).transit({opacity: 1}, 200);

                    if (view.privateVars.players.has(data.oldId)) {
                        view.privateVars.players.get(data.oldId).pause();
                    }
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
